<template>
  <div>
    <div class="flex items-start justify-between">
      <collapse-body-card
        label="Informasi"
        container-class="min-w-[250px] pb-0"
      />
      <collapse-body-card
        label="QTY"
        container-class="w-[70px] pb-0"
      />
    </div>
    <div
      v-for="product in products"
      :key="product.marketplace_product_id"
      class="text-[#333333] border-b-[1px] pb-[12px] mb-[12px] last:mb-0 last:border-b-0 border-b-[#E2E2E2]"
    >
      <product-card-item :product="product">
        <p
          v-if="!product.is_bundling"
          class="text-[#626262] text-[12px] m-0"
        >
          {{ product.variant_name || '-' }}
        </p>
        <div
          v-else
          class="bg-[#dbeafe] rounded-full px-[8px] py-[4px] w-fit flex items-center gap-[8px] justify-center"
        >
          <span class="k-gift text-[#08a0f7]" />
          <span class="text-[#626262] text-xs block">Bundling</span>
        </div>
      </product-card-item>
      <div
        v-if="product.is_bundling"
        class="border border-[#e7e7e7] m-[12px] pt-[12px] rounded-md bg-[#f4f4f4] mt-0"
      >
        <product-card-item
          v-for="bundle in product.product_bundles"
          :key="bundle.order_product_bundle_id"
          :product="bundle"
          quantity-align="right"
        >
          <p
            class="text-[#626262] text-[12px] m-0"
          >
            {{ product.variant_name || '-' }}
          </p>
        </product-card-item>
      </div>
    </div>
  </div>
</template>

<script>
import CollapseBodyCard from './CollapseBodyCard.vue'
import ProductCardItem from './ProductCardItem.vue'

export default {
  name: 'ProductCard',
  components: {
    CollapseBodyCard,
    ProductCardItem,
  },
  props: {
    products: {
      type: Array,
      required: true,
      default: () => [{
        product_name: '-',
        variant_name: '-',
      }],
    },
  },
  data() {
    return {
      dataDetail: this.products[0],
    }
  },
}
</script>
